<div>
  <p class="text-center">
    <span class="highlight">{{ totals.totalValue | gungCurrency: totals.totalCurrency:'symbol-narrow':'1.2-2' }}</span>
  </p>
</div>
